import { lazy } from 'react';
import { TypeForm } from '@fm-nx/contentful-types';
const FormContact = lazy(() => import('../form-contact/form-contact'));

export const Form = ({ form }: { form: TypeForm<'WITHOUT_UNRESOLVABLE_LINKS'> }) => {
    if (form.fields.id === 'contact') {
        return <FormContact form={form} />;
    }
    return null;
};
export default Form;
